import { FormActions } from "../../components/common/FormActions";
import {
  createColumn,
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_PERIOD_CONFIGURABLES } from "../../utils/urls";

export const usePeriodConfigurables = () => {
  const tableColumns = () => [
    ...[
      "validity_period",
      "number_of_months",
      "status",
      "created_at",
      "actions",
    ].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(URL_PERIOD_CONFIGURABLES, item?.id)}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      validity_period: item?.validity_period,
      number_of_months: item?.number_of_months,
      status: item?.status,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_PERIOD_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
